App.controller('HealthPzuwDetailsCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'insuranceService', 'statesService', '$filter', 'profileService', '$timeout', 'dataUser', 'Blob', 'FileSaver', '$rootScope', 'healthInsuranceService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, insuranceService, statesService, $filter, profileService, $timeout, dataUser, Blob, FileSaver, $rootScope, healthInsuranceService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja (dane)';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.health.list';
    $scope.$emit('link', $scope.link);

    $scope.data = $scope.stateParams.package;
    if (!$scope.data) {
        $state.go('root.health.list');
        return;
    }


    if ($scope.data.partner && Object.keys($scope.data.partner).length) {
        $scope.partner_length = true;
    }

    if ($scope.data.children.length) {
        $scope.children_length = true;
    }

    if ($scope.data.seniors.length) {
        $scope.seniors_length = true;
    }

    $scope.getDeclaration = function (ev, value) {
        let el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
        let id = value.uuid, barcode = value.barcode || '';
        healthInsuranceService.getDeclaration(id).then(function (data) {
            if (data.status === 200) {
                let blobData = new Blob([data.data], {type: 'application/pdf'});
                FileSaver.saveAs(blobData, 'Deklaracja_' + barcode + '.pdf');
            }

            $timeout(function () {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    };
}]);
